<template>
  <div>
    <div class="mb-3 d-inline-block">
      <v-btn
        v-for="item in ToggleValues"
        :key="item"
        :variant="item == toggleValue ? 'flat' : 'plain'"
        rounded="0"
        elevation="2"
        @click="getCustomerReport(item)"
      >
        {{ item }}
      </v-btn>
    </div>
    <LoadingCircle v-if="isLoading" />
    <v-table v-else fixed-header density="compact">
      <thead>
        <tr class="overview__header">
          <th>Customer company name</th>
          <th>Business partner count</th>
          <th>Supplier count</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.customerCompanyName">
          <td>{{ item.customerCompanyName }}</td>
          <td>{{ item.businessPartnerCount }}</td>
          <td>{{ item.supplierCount }}</td>
        </tr>
      </tbody>
    </v-table>
  </div>
</template>

<script setup lang="ts">
import LoadingCircle from "@/components/custom/LoadingCircle.vue";
import type CustomerCrossQuestionnaireReceivers from "@/models/customerCrossQuestionnaireReceivers";
import axios from "axios";
import { onMounted, ref } from "vue";

const isLoading = ref(false);
const items = ref(new Array<CustomerCrossQuestionnaireReceivers>());

enum ToggleValues {
  All = "All",
  TierOne = "Tier One",
}

const toggleValue = ref(ToggleValues.TierOne);

onMounted(async () => await getCustomerReport(toggleValue.value));

const getAll = async (): Promise<CustomerCrossQuestionnaireReceivers[]> => {
  const response = await axios.get<CustomerCrossQuestionnaireReceivers[]>(
    "/api/admin/customer-report"
  );
  return response.data;
};

const getTierOne = async (): Promise<CustomerCrossQuestionnaireReceivers[]> => {
  const response = await axios.get<CustomerCrossQuestionnaireReceivers[]>(
    "/api/admin/customer-report/tier-one"
  );
  return response.data;
};

const getData = async (): Promise<CustomerCrossQuestionnaireReceivers[]> => {
  switch (toggleValue.value) {
    case ToggleValues.All:
      return await getAll();
    case ToggleValues.TierOne:
      return await getTierOne();
    default:
      throw new Error("Invalid toggle value");
  }
};

const getCustomerReport = async (newToggleValue: ToggleValues) => {
  isLoading.value = true;
  toggleValue.value = newToggleValue;
  items.value = await getData();
  isLoading.value = false;
};
</script>

<style scoped lang="scss">
.overview__header > th {
  font-weight: bold !important;
}
</style>
